import React from 'react'
import { useRouter } from 'next/router'

import ForYou from 'app/PelatihanMandiriPage/pages/ForYou'
import PageHeader from 'app/PelatihanMandiriPage/components/PageHeader'
import { shouldHideNav } from 'app/PelatihanMandiriPage/helper'
import { useDesktopForYouTabToggle } from 'app/PelatihanMandiriPage/hooks/useDesktopForYouTabToggle'
import { useScreenSizeContext } from 'utils/hooks/context/useScreenSizeContext'

// get from local storage
const BelajarMandiriIndex = () => {
  const { isDesktop: isDesktopScreenSize } = useScreenSizeContext()
  const router = useRouter()
  const { isEnabled: shouldShowForYouTab } = useDesktopForYouTabToggle()

  React.useEffect(() => {
    if (isDesktopScreenSize && !shouldShowForYouTab) {
      router.replace('/pelatihan-mandiri/daftar-topik')
    }
  }, [isDesktopScreenSize, router, shouldShowForYouTab])

  if (isDesktopScreenSize && !shouldShowForYouTab) return null

  return <ForYou isDesktop={isDesktopScreenSize} />
}

BelajarMandiriIndex.layoutOpts = {
  hasHeader: !shouldHideNav(),
  className: 'text-default bg-gray-10',
  header: PageHeader,
  enableDesktopLayout: true,
}

export default BelajarMandiriIndex
